module.exports = __webpack_public_path__ + "static/img/qx_jcjg_icon.png";